export const STATUS_ERROR = 'email/STATUS_ERROR';
export const STATUS_SUCCESS = 'email/STATUS_SUCCESS';
